var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68527 5.02163C9.8814 4.82724 9.88281 4.51066 9.68842 4.31453C9.49403 4.1184 9.17745 4.11699 8.98132 4.31138L7.78483 5.49724C7.33418 5.94386 6.96587 6.3089 6.70466 6.63414C6.43304 6.97236 6.23642 7.31565 6.1839 7.72773C6.16087 7.90841 6.16087 8.09126 6.1839 8.27195C6.23642 8.68402 6.43304 9.02731 6.70466 9.36553C6.96587 9.69078 7.33418 10.0558 7.78482 10.5024L8.98132 11.6883C9.17745 11.8827 9.49403 11.8813 9.68842 11.6851C9.88281 11.489 9.8814 11.1724 9.68526 10.978L8.50995 9.81317C8.03296 9.34041 7.70576 9.01505 7.48435 8.73937C7.26929 8.47157 7.19551 8.29956 7.17587 8.14551C7.16354 8.04878 7.16354 7.9509 7.17587 7.85417C7.19551 7.70012 7.26929 7.5281 7.48435 7.26031C7.70576 6.98462 8.03296 6.65926 8.50995 6.1865L9.68527 5.02163Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/Left.0f326dd6f3e7b116d1be981ff1a965fc.svg";
export { ForwardRef as ReactComponent };